<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-also-by element-with-heading" id="also-by">
<div class="heading heading-with-title heading-without-image" id="also-by-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Books in The Circuit Fae Series By Genevieve Iseult Eldredge</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<p class="first first-in-chapter first-full-width also-by-content"><a class="content-external-link" href="http://www.fireflyhillpress.com/moribund" target="_blank">Moribund - Book 1</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="http://www.firelfyhillpress.com/derailed" target="_blank">Derailed - Novella 1.5</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="http://www.fireflyhillpress.com/ouroboros" target="_blank">Ouroboros - Book 2</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="http://www.fireflyhillpress.com/dethroned" target="_blank">Dethroned - Novella  2.5</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="http://www.fireflyhillpress.com/inimical" target="_blank">Inimical - Book 3</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="http://www.fireflyhillpress.com/rekindled" target="_blank">Rekindled - Novella 3.5</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="http://www.fireflyhillpress.com/nemesis" target="_blank">Nemesis - Book 4</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// booksinthecircuitfaeseriesbygenevieveiseulteldredge.vue?2a7232c6